import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CustomButton from '../components/styled/CustomButton'
import { getAllData } from '../apis/generalApis'
import { Button } from '@mui/material'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const FrequentlyAskedQuestionsModal = ({
  handleFrequentlyAskedQuestionsModal,
  modalOpen = false,
  screen = '',
}) => {
  const [FAQs, setFAQs] = React.useState([])

  React.useEffect(() => {
    getFAQs()
  }, [])

  const getFAQs = async () => {
    try {
      let result = await getAllData('get-faqs')
      if (result?.success === true && result?.data != null) {
        setFAQs(result?.data)
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => handleFrequentlyAskedQuestionsModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="frequently-asked-questions-modal">
          <div>
            <h3 className="fs-24 mb-3 fw-bold">Frequently Asked Questions</h3>
            <div className="text-left">
              {FAQs?.map((faq, index) => (
                <div key={faq.id}>
                  <p className="fs-16 mt-2 font-weight-bold mb-1">
                    {faq.question}
                  </p>
                  <p className="fs-16">{faq.answer}</p>
                </div>
              ))}
              <div
                className="mt-4 pointer"
                onClick={() => {
                  if (screen === 'client-footer') {
                    handleFrequentlyAskedQuestionsModal(false)
                    return
                  }
                  handleFrequentlyAskedQuestionsModal(false)
                }}
              >
                <Button fullWidth id="btn-primary-no-shadow">
                  Continue
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default FrequentlyAskedQuestionsModal
